// src/utils/cookies.ts
import { NextResponse } from "next/server";

const APP_ENV = process.env.APP_ENV ?? "local";
export const COOKIE_NAME = process.env.COOKIE_NAME ?? "mpsession_local";
export const COOKIE_DOMAIN = process.env.COOKIE_DOMAIN ?? ".maluperezonline.cl";
export const REFRESH_COOKIE_NAME = process.env.REFRESH_COOKIE_NAME ?? "mpsession_refresh_local";
export const DEVICE_COOKIE_NAME = process.env.DEVICE_COOKIE_NAME ?? "mpdevice_local";

/**
 * Crea una respuesta con la cookie de sesión configurada.
 * Úsalo en route handlers o en el proxy.ts.
 */
export function setSessionCookie(
  response: NextResponse,
  token: string,
  expiresAt: Date,
  cookieName: string = COOKIE_NAME
): NextResponse {
  const maxAge =
    expiresAt?.getTime() && expiresAt.getTime() > Date.now()
      ? expiresAt.getTime() - Date.now()
      : 7 * 24 * 60 * 60 * 1000; // 7 días por defecto

  response.cookies.set({
    name: cookieName,
    value: token,
    httpOnly: true,
    secure: APP_ENV !== "local",
    sameSite: "lax",
    domain: APP_ENV === "local" ? undefined : COOKIE_DOMAIN,
    path: "/",
    maxAge,
  });

  return response;
}

export function clearSessionCookie(
  response: NextResponse,
  cookieName: string = COOKIE_NAME
): NextResponse {
  response.cookies.set({
    name: cookieName,
    value: "",
    httpOnly: true,
    secure: APP_ENV !== "local",
    sameSite: "lax",
    domain: APP_ENV === "local" ? undefined : COOKIE_DOMAIN,
    path: "/",
    maxAge: 0,
  });

  return response;
}

export function setRefreshCookie(
  response: NextResponse,
  token: string,
  expiresAt: Date
): NextResponse {
  return setSessionCookie(response, token, expiresAt, REFRESH_COOKIE_NAME);
}

export function clearRefreshCookie(response: NextResponse): NextResponse {
  return clearSessionCookie(response, REFRESH_COOKIE_NAME);
}

export function setDeviceCookie(
  response: NextResponse,
  deviceId: string,
  expiresAt: Date
): NextResponse {
  return setSessionCookie(response, deviceId, expiresAt, DEVICE_COOKIE_NAME);
}

export function clearDeviceCookie(response: NextResponse): NextResponse {
  return clearSessionCookie(response, DEVICE_COOKIE_NAME);
}
